// Constants used in redcap export
export const antibiogo_automatic_upload_antibiotic_table =
  "antibiogo_automatic_upload_antibiotic_table";
export const complete: number = 2;
export const suggested = 1;
export const notSuggested = 0;
export const antibiogo_mic = "antibiogo_mic";
